import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "438",
  height: "438",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M420 356V219H219V18H82q-27 0-45 19-19 18-19 45v137h201v201h137q27 0 45-19 19-18 19-45m18-274v274q0 34-24 58t-58 24H82q-34 0-58-24T0 356V82q0-34 24-58T82 0h274q34 0 58 24t24 58"
    }, null, -1)
  ])))
}
export default { render: render }